function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\r\n    .fileCheck{\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n    }\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(453,99)",
  d: "m0 0h482l10 3 10 6 17 16 4 3v2h2v2h2l4 4v2l4 2v2l4 2 7 8 19 19 2 1v2l4 2 7 8 83 83 6 5 6 7 2 1v2l4 2 8 8v2l4 2 12 12v2l4 2 12 12v2l4 2v2l4 2 8 8v2l4 2v2l4 2 4 4v2h2v2h2l4 4v2l4 2 4 4v2h2v2h2l4 4v2l4 2 8 8v2l4 2v2l4 2 8 8v2l4 2 56 56 14 16 6 10 1 3v13l-6 13-4 6-10 6-10 4-2 1-1-2h-238l-28-1-23-2-15-3-16-5-11-5-10-6-9-7-10-9-8-8-10-14-8-13-8-20-3-9-3-19-1-10-1-25v-202l-1-9-465 1-22 2-15 4-14 7-12 9-3 3h-2v2h-2l-2 4-8 10-7 12-6 13-3 12-2 20-1 261v773l2 21 4 16 8 16 8 11 13 13 13 9 15 7 17 4 20 2 31 1h400l36 1 13 2 10 5 4 5 4 10 1 4v15l-4 10-5 6-11 6-7 3h-476l-19-2-18-3-17-5-16-7-15-8-12-9-11-10-7-6-9-11-10-13-9-15-8-17-7-21-3-17-2-25-1-27v-996l2-27 5-25 6-18 8-16 8-14 8-11 7-9 15-15 16-12 21-12 19-8 17-4 29-3zm513 115v186l2 16 5 15 6 10 9 9 11 8 10 4 12 3 7 1 21 1h28l130-1 8-1-2-5-12-12-8-7-4-5-74-74-1-2h-2l-2-4-68-68-8-7-67-67z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(1291,601)",
  d: "m0 0h13l11 3 10 5 6 7 2 6 1 378 31 6 25 7 23 8 29 14 17 10 15 10 13 10 10 9 8 7 7 6 7 8 10 11 11 14 11 16 13 22 12 25 6 15 10 32 6 21 2-1v99l-3 1-1 7 2-5h1v7l1 2v15h-2l-1-8-2-5-2-1-1 8-8 28-8 20-10 19-10 18-12 17-12 16-9 11-9 10-7 8-11 9-12 10-16 11-17 11-10 6-23 11-20 8-24 8-18 5h-2l-1 2v-2l-5 2v2h-97l1-2-25-7-30-10-19-7-28-14-23-14-14-11-13-11-7-7-8-7-4-4v-2l-3-1-7-8-13-16-14-21-8-14-13-27-11-29-6-21-5-26-2-16-1-16v-21l2-27 8-37 8-26 13-30 13-23 7-11 12-17 14-17 15-16 8-8 11-9 15-12 20-13 16-9 29-14 18-6 34-8 20-3h4v-288l1-90 2-9 4-6 8-5zm0 466-26 2-19 3-26 8-24 10-20 11-11 8-8 6-15 13-17 17-11 14-13 18-12 24-6 14-10 30-4 21-2 20v26l2 21 3 18 6 21 11 28 8 15 10 16 13 16 9 10 17 17 14 11 16 11 16 9 16 8 15 6 19 6 19 4 17 2h45l25-4 21-6 20-7 22-11 15-9 13-9 10-8 10-9 7-6 7-8 8-9 12-16 9-15 8-16 7-16 6-19 5-23 3-22v-37l-4-29-7-25-6-17-12-25-10-17-10-14-9-10-7-8-14-13-17-13-14-9-12-7-17-8-21-8-22-6-18-3-28-2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(1392,1200)",
  d: "m0 0h12l10 3 8 6 7 7 6 11-1 10-7 14-12 19-17 25-9 13-11 15-12 18-10 14-13 18-10 15-12 17-11 12-7 8-14 10-9-1-14-7-18-12-18-14-17-13-13-11-10-8-19-19-5-9-1-2v-9l4-11 5-8 12-9 9-4 9 1 16 8 14 10 8 6 11 8 7 7 11 8h6l8-9 9-12 15-22 8-12 12-17 11-15 9-14 8-11 10-15 9-10 7-6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(1598,1220)",
  d: "m0 0h2v8l-2-1-1-4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(1228,1597)",
  d: "m0 0 5 2v1h-8v-2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(1599,1236)",
  d: "m0 0 1 3h-4l-1-2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(1240,1598)",
  d: "m0 0 3 1-3 1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(975,232)",
  d: "m0 0 3 1h-3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(968,217)",
  d: "m0 0"
}), /*#__PURE__*/React.createElement("path", {
  className: "fileCheck",
  transform: "translate(967,216)",
  d: "m0 0"
}));

var SvgFileCheck = function SvgFileCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fileCheck",
    viewBox: "0 0 1600 1600",
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fileCheck.dda0c631.svg";
export { ForwardRef as ReactComponent };